import './style.scss'

const LinkAccount = () => {
  return (
    <div className="row link-bank-account">
      -{/*{isBankAccountAdded || showAddAccountButton ? (*/}
      {/*  <Button*/}
      {/*    type={BUTTON_TYPES.GHOST}*/}
      {/*    onClick={handleBankAccount}*/}
      {/*    className="link-bank-account__btn"*/}
      {/*    icon={showAddAccountButton && <Plus16 />}*/}
      {/*    upperCase={showAddAccountButton}*/}
      {/*  >*/}
      {/*    <div className="row">*/}
      {/*      {showAddAccountButton ? (*/}
      {/*        <>{BTN_TXT.ADD_ACCOUNT}</>*/}
      {/*      ) : (*/}
      {/*        <>*/}
      {/*          {BTN_TXT.LINKED_ACCOUNT} &nbsp;*/}
      {/*          <Redirect16 />*/}
      {/*        </>*/}
      {/*      )}*/}
      {/*    </div>*/}
      {/*  </Button>*/}
      {/*) : (*/}
      {/*  '-'*/}
      {/*)}*/}
    </div>
  )
}

export default LinkAccount
